import PropTypes from 'prop-types';

import { workReportLineStatus } from '../../../../utils/dataStatus';
import { Line } from '../../../../utils/globalPropTypes';

const ProgramPointFooter = ({
  totalValue,
  line,
  isFixedOrReturnedAndHasPP,
  displayFixedlabel,
  quantityTotalReturn
}) => {
  const isLineReturnStatus = line?.estadoEnum === workReportLineStatus.devolver;

  return (
    <>
      <hr className="divide-line" />
      {isFixedOrReturnedAndHasPP && displayFixedlabel ? (
        <div className="label-total-container">
          <span className="d-flex align-items-center fw-bold fs-5">
            {parseFloat(totalValue).toLocaleString('es-AR') || '--'} {'  '}
            {line?.unidadMedida}
          </span>
          <span className="d-flex align-items-center px-3">Cantidad total </span>
          {isFixedOrReturnedAndHasPP && displayFixedlabel && ` | `}
          <span
            className="d-flex px-3 fs-5"
            style={{ color: isLineReturnStatus ? '#ff0000c2' : '#44adde' }}
          >
            {isFixedOrReturnedAndHasPP &&
              displayFixedlabel &&
              ` ${quantityTotalReturn} ${line?.unidadMedida} cantidad 
        ${isLineReturnStatus ? 'devuelta' : 'fijada'} `}
          </span>
        </div>
      ) : (
        <div className="label-total-container">
          <span className="d-flex align-items-center fw-bold fs-5">
            {parseFloat(totalValue).toLocaleString('es-AR') || '--'} {'  '}
            {line?.unidadMedida}
          </span>
          <span className="d-flex align-items-center px-3">cantidad total notificada </span>
          {isFixedOrReturnedAndHasPP && displayFixedlabel && ` | `}
          <span
            className="d-flex px-3 fs-5"
            style={{ color: isLineReturnStatus ? '#ff0000c2' : '#44adde' }}
          >
            {isFixedOrReturnedAndHasPP &&
              displayFixedlabel &&
              ` ${quantityTotalReturn} ${line?.unidadMedida} cantidad 
        ${isLineReturnStatus ? 'devuelta' : 'fijada'} `}
          </span>
        </div>
      )}

      <hr className="divide-line" />
    </>
  );
};

export default ProgramPointFooter;

ProgramPointFooter.propTypes = {
  quantityTotalReturn: PropTypes.string,
  displayFixedlabel: PropTypes.bool.isRequired,
  isFixedOrReturnedAndHasPP: PropTypes.bool.isRequired,
  totalValue: PropTypes.number,
  line: Line
};

ProgramPointFooter.defaultProps = {
  quantityTotalReturn: '',
  totalValue: null,
  line: {
    positionName: '',
    lineName: '',
    idParteDiario: 0,
    estadoEnum: 0,
    tienePuntosPrograma: false
  }
};
